<template>
  <div class="device-status">
    <div class="header">
      <div class="title">
        <!-- <img src="@/assets/visualization/logo.svg" class="logo" /> -->
        <span>设备实时状态图</span>
      </div>
      <div class="update-time">
        最后更新：{{ lastUpdate }}
      </div>
    </div>
    
    <div class="status-legend">
      <div class="legend-item">
        <span class="status-dot ecqStatus-001"></span>
        运行（绿色）
      </div>
      <div class="legend-item">
        <span class="status-dot ecqStatus-010"></span>
        待机（黄色）
      </div>
      <div class="legend-item">
        <span class="status-dot ecqStatus-100"></span>
        故障（红色）
      </div>
      <div class="legend-item">
        <span class="status-dot ecqStatus-000"></span>
        停机（蓝色）
      </div>
    </div>
    
    <div class="device-grid-container">
      <div class="device-grid" ref="deviceGrid">
        <div v-for="(device, index) in devices" :key="index" :class="['device-card', device.ecqStatus?'ecqStatus-'+device.ecqStatus.value:'ecqStatus-000']" @click="openDeviceDetail(device)">
          <div class="device-icon">
             <span v-if="device.ecqStatus&&device.ecqStatus.value === '001'" class="icon-running">●</span>
            <span v-else-if="device.ecqStatus&&device.ecqStatus.value === '010'" class="icon-standby">⚠</span>
            <span v-else-if="device.ecqStatus&&device.ecqStatus.value === '100'" class="icon-fault">✕</span>
            <span v-else-if="device.ecqStatus&&device.ecqStatus.value === '000'" class="icon-planned-stop">i</span>
          </div>
          <div class="device-name" :style="{'max-width':deviceCardWidth + 'px'}">{{ device.deviceName }}</div>
          <div class="device-code">{{device.deviceCode }}</div>
          <!-- <div class="device-status-text" :style="{'max-width':deviceCardWidth + 'px'}">{{ device.ecqStatusText }}</div> -->
          <div class="device-info" :style="{'max-width':deviceCardWidth + 'px'}" v-if="device.productionNo&&device.productionNo.length>0">制令单：{{ device.productionNo.join(',') }}</div>
          <div style="visibility: hidden;height: 23px;width: 100%;" v-else></div>
        </div>
      </div>
    </div>
      <!-- 设备详情模态框 -->
  <div v-if="showDeviceDetail" class="device-detail-modal">
    <div class="modal-content">
      <div class="modal-header">
        <h2>设备详情</h2>
        <button class="close-btn" @click="closeDeviceDetail">×</button>
      </div>
      <div class="modal-body">
        <div class="basic-info">
          <h3>基本信息</h3>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">设备名称</span>
              <span class="info-value">{{ selectedDevice.deviceName}}</span>
            </div>
            <div class="info-item">
              <span class="info-label">设备编码</span>
              <span class="info-value">{{ selectedDevice.deviceCode}}</span>
            </div>
            <div class="info-item">
              <span class="info-label">设备状态</span>
              <span class="info-value">{{ selectedDevice.ecqStatusText }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">最后更新</span>
              <span class="info-value">{{ selectedDevice.changeTime }}</span>
            </div>
            <div class="info-item full-width">
              <span class="info-label">制令单</span>
              <span class="info-value">{{ selectedDevice.productionNo&&selectedDevice.productionNo.length>0?selectedDevice.productionNo.join(',') :'' }}</span>
            </div>
          </div>
        </div>
        <div class="oee-data">
          <h3>OEE数据</h3>
          <div class="oee-grid">
            <div class="oee-item">
              <span class="oee-label">可用率</span>
              <span class="oee-value">{{selectedDevice.useRate||0}}%</span>
            </div>
            <div class="oee-item">
              <span class="oee-label">性能率</span>
              <span class="oee-value">{{selectedDevice.motoRate||0}}%</span>
            </div>
            <div class="oee-item">
              <span class="oee-label">合格率</span>
              <span class="oee-value">{{selectedDevice.passRate||0}}%</span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="close-btn" @click="closeDeviceDetail">关闭</button>
      </div>
    </div>
  </div>
  </div>


</template>

<script>
import { andonEcqDeviceQueryList,deviceQuery } from "@/api/bigscreen/bigscreen";
export default {
  props: {
    organizationId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      lastUpdate: '2026/03/05 13:34:50',
      devices: [],
      scrollTimer: null,
      scrollSpeed: 2, // 滚动速度
      showDeviceDetail: false,
      selectedDevice: {},
      // WebSocket相关状态
      ws: null,
      wsUrl: 'ws://localhost:8080/ws', // WebSocket服务器地址
      wsConnected: false,
      wsReconnectAttempts: 0,
      maxReconnectAttempts: 5,
      reconnectDelay: 3000
    }
  },
  computed: { 
    deviceCardWidth(){
      const width = document.body.clientWidth - 60
      return width/4 - 40 - 30
    }
  },
  created() {
    // 初始化时设置当前时间作为最后更新时间
    this.updateLastTime();
    this.getList();
  },
  mounted() {
    // 组件挂载后开始滚动
    this.startScroll();
    // 初始化WebSocket连接
    this.initWebSocket();
  },
  beforeUnmount() {
    // 组件卸载前清除定时器
    if (this.scrollTimer) {
      clearInterval(this.scrollTimer);
    }
    // 关闭WebSocket连接
    if (this.ws) {
      this.ws.close();
    }
  },
  methods: {
    getList(){
      andonEcqDeviceQueryList({departmentId:this.organizationId}).then(res=>{
        if(res.success){ 
          const devicesIds= []
          this.devices = res.result.map(item=>{
            if(item.ecqStatus){
                const statusMap = {
                  '000': '停机',
                  '100': '故障',
                  '001': '运行',
                  '010': '待机'
                };
                item.ecqStatusText  = statusMap[item.ecqStatus.value]
            }else{
            item.ecqStatus={value:'000'}
              item.ecqStatusText  = '停机'
            }
            devicesIds.push(item.deviceId)
            return item
          })
          deviceQuery({devIds:devicesIds}).then(k=>{
            k.result.map(item=>{
              this.devices.map(k=>{
                if(k.deviceId==item.devId){
                  if(k.productionNo){
                    k.productionNo = []
                  }
                  k.productionNo.push(item.productionNo)
                }
              })
            })
          })
        }
      })
    },
    updateLastTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      this.lastUpdate = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    },
    startScroll() {
      const deviceGrid = this.$refs.deviceGrid;
      console.log(deviceGrid,'deviceGrid')
      if (!deviceGrid) return;

      const deviceCards = deviceGrid.querySelectorAll('.device-card');
      console.log(deviceCards,'deviceCards')
      if (deviceCards.length <= 8) return;

      // 计算单张卡片的高度（包括间距）
      const cardHeight = deviceCards[0].offsetHeight + 30; // 卡片高度 + 行间距
      const totalRows = 2; // 总共有2行
      let currentRow = 0;

      const scrollStep = () => {
        currentRow++;
        if (currentRow >= totalRows) {
          // 滚动到末尾后，瞬间重置到起始位置
          deviceGrid.style.transition = 'none';
          deviceGrid.style.transform = 'translateY(0)';
          // 等待重绘后再继续滚动
          setTimeout(() => {
            deviceGrid.style.transition = 'transform 0.5s ease';
            currentRow = 1;
            const scrollTop = currentRow * cardHeight;
            deviceGrid.style.transform = `translateY(-${scrollTop}px)`;
            setTimeout(scrollStep, 4000);
          }, 100);
          return;
        }

        // 平滑滚动到下一行
        deviceGrid.style.transition = 'transform 0.5s ease';
        const scrollTop = currentRow * cardHeight;
        deviceGrid.style.transform = `translateY(-${scrollTop}px)`;

        // 初始延迟后开始滚动
        setTimeout(scrollStep, 4000);
      };

      // 初始延迟后开始滚动
      setTimeout(scrollStep, 4000);
    },
    openDeviceDetail(device) {
      // 暂停滚动
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
      }
      // 设置选中的设备信息
      this.selectedDevice = device;
      // 显示模态框
      this.showDeviceDetail = true;
    },
    closeDeviceDetail() {
      // 关闭模态框
      this.showDeviceDetail = false;
      // 重新开始滚动
      this.startScroll();
    },
    getWebSocketUrl() {
    // 获取用户ID
    // const userId = store.state.userinfo?.userId
    // if (!userId) {
    //   return null
    // }
    
    // 获取当前页面的基础URL
    const baseUrl = window.location.origin

    // 替换协议：http -> ws, https -> wss
    const wsProtocol = baseUrl.startsWith('https') ? 'wss' : 'ws'
    const wsBaseUrl = baseUrl.replace(/^https?:/, wsProtocol + ':')
    
    // 拼接WebSocket路径
    return `${wsBaseUrl}/app/ws/andon`
    // return `ws://192.168.1.67:7010/app/ws/andon`
  },
    // WebSocket相关方法
    initWebSocket() {
       this.wsUrl = this.getWebSocketUrl()
    if (!this.wsUrl) {
      console.log('WebSocket地址生成失败')
      return
    }

    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      return
    }
      try {
        this.ws = new WebSocket(this.wsUrl);
        
        this.ws.onopen = () => {
          console.log('WebSocket连接成功');
          this.wsConnected = true;
          this.wsReconnectAttempts = 0;
          // 发送订阅消息
          const topic = '/app/andon/device';
          const subscribeMsg = {
              action: 'subscribe',
              topic: topic
          };
          this.ws.send(JSON.stringify(subscribeMsg));
          console.log('已发送订阅消息:', subscribeMsg);
        };
        this.ws.onmessage = (event) => {
          console.log('收到WebSocket消息:', event.data);
          this.handleWebSocketMessage(event.data);
        };
        
        this.ws.onclose = () => {
          console.log('WebSocket连接关闭');
          this.wsConnected = false;
          this.reconnectWebSocket();
        };
        
        this.ws.onerror = (error) => {
          console.error('WebSocket错误:', error);
          this.wsConnected = false;
        };
      } catch (error) {
        console.error('WebSocket初始化失败:', error);
        this.reconnectWebSocket();
      }
    },
    reconnectWebSocket() {
      if (this.wsReconnectAttempts < this.maxReconnectAttempts) {
        this.wsReconnectAttempts++;
        console.log(`WebSocket重连中... (${this.wsReconnectAttempts}/${this.maxReconnectAttempts})`);
        
        setTimeout(() => {
          this.initWebSocket();
        }, this.reconnectDelay);
      } else {
        console.error('WebSocket重连失败，已达到最大重连次数');
      }
    },
    handleWebSocketMessage(message) {
      try {
        const data = JSON.parse(message);
        console.log('WebSocket数据:', data);
        // 处理不同类型的消息
        switch (data.type) {
          case 'device_status':
            this.handleDeviceUpdate(data.data);
            break;
          default:
            console.log('未知消息类型:', data.type);
        }
      } catch (error) {
        console.error('解析WebSocket消息失败:', error);
      }
    },
    handleDeviceUpdate(deviceData) {
      const deviceList = deviceData.message;
      const statusMap = {
          '000': '停机',
          '100': '故障',
          '001': '运行',
          '010': '待机'
        };
      //           item.ecqStatusText  = statusMap[item.ecqStatus.value]
      deviceList.map(item=>{
         const index = this.devices.findIndex(device => device.deviceId === item.deviceId);
         const  ecqStatus={label:statusMap[item.ecqStatus],value:item.ecqStatus}
         this.devices[index] = { ...this.devices[index], ecqStatus,ecqStatusText:statusMap[item.ecqStatus] };
      })
      // 更新最后更新时间
      this.updateLastTime();
    },
  }
}
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.device-status {
  width: 100vw;
  height: 100vh;
  background: #1a1a1a;
  color: #fff;
  font-family: "Alibaba PuHuiTi 2.0", 'Avenir', Helvetica, Arial, sans-serif;
  padding: 30px;
  overflow: hidden;

  // 设备详情模态框
  .device-detail-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;

    .modal-content {
      width: 600px;
      background: #2c2c2c;
      border-radius: 10px;
      overflow: hidden;

      .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        // background: #1890FF;
        border-bottom: 1px solid #4c4c4c;

        h2 {
          font-size: 24px;
          font-weight: bold;
          color: #fff;
        }

        .close-btn {
          background: none;
          border: none;
          font-size: 32px;
          color: #fff;
          cursor: pointer;
          padding: 0;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;

          &:hover {
            opacity: 0.8;
          }
        }
      }

      .modal-body {
        padding: 30px;

        .basic-info {
          margin-bottom: 30px;

          h3 {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 20px;
            color: #fff;
          }

          .info-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 20px;

            .info-item {
              background: rgba(255, 255, 255, 0.05);
              padding: 15px;
              border-radius: 8px;

              &.full-width {
                grid-column: 1 / -1;
              }

              .info-label {
                display: block;
                font-size: 14px;
                color: #999;
                margin-bottom: 5px;
              }

              .info-value {
                display: block;
                font-size: 18px;
                color: #fff;
                font-weight: bold;
              }
            }
          }
        }

        .oee-data {
          h3 {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 20px;
            color: #fff;
          }

          .oee-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;

            .oee-item {
              background: rgba(255, 255, 255, 0.05);
              padding: 15px;
              border-radius: 8px;
              text-align: center;

              .oee-label {
                display: block;
                font-size: 14px;
                color: #999;
                margin-bottom: 5px;
              }

              .oee-value {
                display: block;
                font-size: 24px;
                color: #1890FF;
                font-weight: bold;
              }
            }
          }
        }
      }

      .modal-footer {
        padding: 20px;
        background: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: flex-end;

        .close-btn {
          padding: 10px 24px;
          background: #333232;
          color: #fff;
          border: none;
          border-radius: 5px;
          font-size: 16px;
          cursor: pointer;

          &:hover {
            background: #40a9ff;
          }
        }
      }
    }
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;

    .title {
      display: flex;
      align-items: center;
      font-size: 48px;
      font-weight: bold;

      .logo {
        width: 60px;
        height: 60px;
        margin-right: 20px;
      }
    }

    .update-time {
      font-size: 24px;
      color: #999;
      background: rgba(255, 255, 255, 0.1);
      padding: 10px 20px;
      border-radius: 20px;
    }
  }

  .status-legend {
    display: flex;
    gap: 40px;
    margin-bottom: 40px;
    padding: 20px 30px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;

    .legend-item {
      display: flex;
      align-items: center;
      font-size: 28px;

      .status-dot {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin-right: 10px;
        display: inline-block;
        &.ecqStatus-001 {
          background: #00B578;
        }
        &.ecqStatus-010 {
          background: #F5B130;
        }
        &.ecqStatus-100 {
          background: #FA5151;
        }
        &.ecqStatus-000 {
          background: #1890FF;
        }
      }
    }
  }

  .device-grid-container {
    overflow: hidden;
    height: calc(100vh - 200px);
    position: relative;

    .device-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 30px;
      transition: transform 0.1s linear;
      width: 100%;

      .device-card {
        border-radius: 15px;
        padding: 40px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        transition: all 0.3s ease;
        min-height: 300px;
        cursor: pointer;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
        }

        &.ecqStatus-001 {
          background: #00B578;
        }
        &.ecqStatus-010 {
          background: #F5B130;
        }
        &.ecqStatus-100 {
          background: #FA5151;
        }
        &.ecqStatus-000 {
          background: #1890FF;
        }
        .device-icon {
          font-size: 60px;
          margin-bottom: 20px;
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;

          .icon-running {
            color: #fff;
          }
          .icon-standby {
            color: #333;
          }
          .icon-fault {
            color: #333;
          }
          .icon-planned-stop {
            color: #fff;
            font-style: italic;
          }
        }

        .device-name {
          font-size: 26px;
          font-weight: bold;
          margin-bottom: 5px;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .device-code{
          font-size: 24px;
          margin-bottom: 10px;
        }

        .device-status-text {
          font-size: 28px;
          margin-bottom: 20px;
          background: rgba(255, 255, 255, 0.2);
          padding: 8px 20px;
          border-radius: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 260px;
          text-align: center;
        }

        .device-info {
          font-size: 16px;
          text-align: center;
          line-height: 1.4;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/device/DeviceStatus.vue